import type { Choice } from '@monthio/react-components/dist/MultipleChoice'

import { FlowPage } from '@monthio/design-system'
import { FormMultipleChoice } from '@monthio/react-components'
import i18next from 'i18next'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { StepComponent } from './steps'

import { ChildrenAgeGroup } from '../../../types'
import { Transition } from '../budgetHelperStateMachine'
import { Step } from './Step'
import { MultipleChoiceWrapper, useStyles } from './StepMultipleChoice'

export const childrenAgeChoices = (): Choice[] => [
	{
		value: ChildrenAgeGroup.AgeGroup0To1,
		label: `0-1 ${i18next.t('budgetHelper-childrenAges')}`,
	},
	{
		value: ChildrenAgeGroup.AgeGroup2To6,
		label: `2-6 ${i18next.t('budgetHelper-childrenAges')}`,
	},
	{
		value: ChildrenAgeGroup.AgeGroup7To17,
		label: `7-17 ${i18next.t('budgetHelper-childrenAges')}`,
	},
	{
		value: ChildrenAgeGroup.AgeGroupOver18,
		label: `18+ ${i18next.t('budgetHelper-childrenAges')}`,
	},
]

export const StyledWrapper = styled(MultipleChoiceWrapper)`
	& > div:first-of-type > div {
		padding-top: 0;
	}
`

export const ChildrenAgesStep: StepComponent = ({ formProps, handleClick }) => {
	const { t } = useTranslation()
	const classes = useStyles()
	const [childrenAges, setChildrenAges] = useState<string[]>([])

	useEffect(() => {
		const childCount = formProps.values.childrenInHousehold || 0
		const ages =
			formProps.values.childrenAges !== null &&
			formProps.values.childrenAges?.length > 0
				? formProps.values.childrenAges
				: Array.from({ length: childCount }, () => ChildrenAgeGroup.Unknown)
		setChildrenAges(ages)
	}, [formProps.values.childrenInHousehold])

	const onClick = (event: any, i: number) => {
		setChildrenAges((prev) => {
			const newAges = [...prev]
			newAges[i] = event.target.value
			if (newAges.every((x) => x !== ChildrenAgeGroup.Unknown)) {
				formProps.setFieldValue('childrenAges', newAges)
				handleClick(Transition.Next)
			}
			return newAges
		})
	}

	return (
		<FlowPage>
			<FlowPage.Content $spacing="l">
				<FlowPage.Header title={t('budgetHelper-childrenAges-title')} />
				<Step>
					{() => {
						return (
							<StyledWrapper $columns={2}>
								{childrenAges.map((_: any, i: number) => (
									<FormMultipleChoice
										id={`childrenAges[${i}]`}
										fieldName={`childrenAges[${i}]`}
										key={`ChildrenAge::${i}`}
										className={`${classes.root} ${classes.button}`}
										choiceAlign="center"
										title={`${t('childrenAge-title')}  ${i + 1}`}
										choices={childrenAgeChoices()}
										onClick={(event: any) => onClick(event, i)}
										selected={formProps.values.childrenAges?.[i]}
									/>
								))}
							</StyledWrapper>
						)
					}}
				</Step>
			</FlowPage.Content>
		</FlowPage>
	)
}
